module.exports = __webpack_public_path__ + "static/media/logo-icon-desktop.1731f2f2.png";